import { ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useCart } from "@/context/CartContext";

export const StickyCartButton = () => {
  const { totalItems, setIsOpen } = useCart();

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Button
        onClick={() => setIsOpen(true)}
        className="relative w-16 h-16 rounded-full btn-hero shadow-2xl hover:scale-110 transition-all duration-300 animate-zen-glow"
      >
        <ShoppingCart className="w-8 h-8" />
        {totalItems > 0 && (
          <Badge className="absolute -top-2 -right-2 bg-destructive text-white min-w-[24px] h-6 rounded-full flex items-center justify-center animate-zen-pulse">
            {totalItems}
          </Badge>
        )}
      </Button>
    </div>
  );
};
